export default __webpack_public_path__ + "images/ie-5ecf710f14d859cbceb6f20ff89a7c13.svg";